import { Grid, makeStyles } from '@material-ui/core';
import { isEmpty } from 'lodash';
import { OnChange } from 'react-final-form-listeners';
import { Trans, useTranslation } from 'react-i18next';
import QCXInfoAlert from '../../shared-components/alert/QCXInfoAlert';
import QCXDynamicFieldGroup from '../../shared-components/dynamic-field-group/QCXDynamicFieldGroup';
import QCXFinalCheckboxField from '../../shared-components/final-checkbox-field/QCXFinalCheckboxField';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXSelectCodigoReceitaAutocomplete from '../../shared-components/final-select-codigo-receita-field/QCXSelectCodigoReceitaAutocomplete';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import { PAGAMENTODI } from '../../ts/common/hooks/useHasPermission/permissionsEnum';
import { useHasPermission } from '../../ts/common/hooks/useHasPermission/useHasPermission';
import { normalizeNumeral, unnormalizeNumeral } from '../../utils/general/general-utils';
import { isNaoCalculadaStatus } from '../../utils/general/operations/operationUtils';
import { formatBrazilianNumericDecimal } from '../../utils/hooks/form/field/formatters';
import QCXFormSubtitle from '../form-title/QCXFormSubtitle';
import QCXFormTitle from '../form-title/QCXFormTitle';
import QCXDeclaracaoImportacaoBondManagerPagamentosRetificacao from './QCXDeclaracaoImportacaoBondManagerPagamentosRetificacao';
import QCXDeclaracaoImportacaoPagamentosRetificadoForm from './QCXDeclaracaoImportacaoPagamentosRetificadoForm';

const useStyles = makeStyles(() => ({
  gridFields: {
    paddingBottom: '16px',
  },
  fakeFields: {
    height: '40px !important',
    paddingBottom: '16px',
  },
}));

export default function QCXDeclaracaoImportacaoPagamentosRetificadoFormStepWizard({
  initialValues,
  handleSubmit,
  isConsult,
  controlComponentProps,
  ...restProps
}) {

  return (
    <QCXFormStepWizard
      initialValues={initialValues}
      onSubmit={handleSubmit}
      controlComponentProps={controlComponentProps}
      {...restProps}
    >
      {({ values, form }) => (
        <>
          <QCXDeclaracaoImportacaoPagamentosRetificadoForm
            values={values}
            isConsult={isConsult}
          />
        </>
      )}

    </QCXFormStepWizard>
  );
}
